import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface UIState {
  theme: 'dark' | 'light';
  language: 'ar' | 'en';
  autoRefreshEnabled: boolean;
  autoRefreshInterval: number;
  
  setTheme: (theme: 'dark' | 'light') => void;
  setLanguage: (language: 'ar' | 'en') => void;
  toggleAutoRefresh: () => void;
  setAutoRefreshInterval: (interval: number) => void;
}

export const useUIStore = create<UIState>()(
  persist(
    (set) => ({
      theme: 'dark',
      language: 'ar',
      autoRefreshEnabled: true,
      autoRefreshInterval: 60,

      setTheme: (theme) => set({ theme }),
      setLanguage: (language) => set({ language }),
      toggleAutoRefresh: () => set((state) => ({ 
        autoRefreshEnabled: !state.autoRefreshEnabled 
      })),
      setAutoRefreshInterval: (interval) => set({ autoRefreshInterval: interval }),
    }),
    {
      name: 'ui-storage',
    }
  )
);